import { render } from "./SvgIcon.vue?vue&type=template&id=bafc3cf6&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=bafc3cf6&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.17_vue@3.2.37_webpack@5.69.0_@swc+core@1.12.11_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bafc3cf6"]])

export default __exports__